module.exports = __webpack_public_path__ + "static/media/dark.5b35c355.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/dark.png
// module id = 2236
// module chunks = 2